import { ScreenSize } from 'ha/modules/UI/constants';

export const STATE_NAME = 'cities';
export const ACTION_PREFIX = 'CITIES';

export const Actions = {
  LOAD_CITIES_START: `${ACTION_PREFIX}/LOAD_CITIES_START`,
  LOAD_CITIES_SUCCESS: `${ACTION_PREFIX}/LOAD_CITIES_SUCCESS`,
  LOAD_CITIES_FAIL: `${ACTION_PREFIX}/LOAD_CITIES_FAIL`,
};

export const ImageHeight = {
  [ScreenSize.XS]: 210,
  [ScreenSize.SM]: 210,
};
